import { COLORS } from '@btime/constants'
import React from 'react'

import { HorizontalLine } from '../../../components/shapes/Line'
import ControlledModal from '../../../components/modals/ControlledModal'
import EditPlaceTypeForm from './EditPlaceTypeForm'
import ModalHeader from './ModalHeader'
import Separator from '../../../components/helpers/Separator'
import PlaceTypeLoader from './_load/PlaceTypeLoader'
import { PermissionChecker } from '../../session'

const PlaceTypesModal = props => {
  return (
    <ControlledModal width="32rem" {...props}>
      <PermissionChecker ownerOnly>
        <PlaceTypeLoader>
          <ModalHeader />
          <HorizontalLine thin lineColor={COLORS.light2} />
          <Separator weight={4} />
          <EditPlaceTypeForm />
        </PlaceTypeLoader>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default PlaceTypesModal
